import { c as _c } from "react/compiler-runtime";
import { ExtraSmall } from "@/src/components/typography";
import type { ReactNode } from "react";

/** Bordered, divided panel that holds a stack of `SummaryRow`s (shared by the review + success steps). */
export function SummaryPanel(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="w-full divide-y rounded-lg border bg-background px-4 text-left">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}

/** One detail row: an accent icon chip, an optional eyebrow label, and its value content. */
export function SummaryRow(t0) {
  const $ = _c(12);
  const {
    icon,
    label,
    children
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-accent text-foreground">{icon}</span>;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label) {
    t2 = label && <ExtraSmall className="block uppercase tracking-[0.12em] text-muted-foreground">{label}</ExtraSmall>;
    $[2] = label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children) {
    t3 = <div className="text-sm text-foreground">{children}</div>;
    $[4] = children;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="min-w-0">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <div className="flex items-start gap-2 py-4">{t1}{t4}</div>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}